import React, { useEffect, useRef } from "react";
import { InfoArrow, ModalClosed, ModalSuccess } from "~misc/icons";
import { isTablet } from "react-device-detect";
import "./index.scss";
import { Form, Formik } from "formik";
import useModalUpdate from "./hooks/useModalUpdate";
import { FormLabel } from "@chakra-ui/react";
import InputField from "~components/Form/components/InputField";
import Select from "~components/Form/components/Select";
import useContexto from "~/fetchs/useContexto";
import useLocal from "~/fetchs/useLocal";
import PropTypes from "prop-types";

const ModalForUpdate = ({ isOpen, onClose, title, trilha, setDados, onConfirm }) => {
  const { initial, validation } = useModalUpdate();
  const modalClasses = isOpen
    ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]"
    : "hidden";
  const overlayClasses = isOpen
    ? "fixed inset-0 bg-black opacity-50"
    : "hidden";
  const formikRef = useRef();

  const {
    optionContextos,
    onChangeContexto,
    contextoSelect,
    SetSelectContexto,
  } = useContexto(formikRef);

  const {
    optionLocais,
    onChangeLocal,
    localSelect,
    SetSelectLocal,
  } = useLocal({ formikRef, trilha });

  const onConfirmed = (e) => onConfirm(e);

  useEffect(() => {
    if (formikRef.current && formikRef.current.values) {
      if (Object.entries(setDados).length > 0) {
        formikRef.current.setFieldValue("contato", setDados.contato);
        SetSelectContexto(setDados.contextoId);
        SetSelectLocal(setDados.localId);
      } else {
        formikRef.current.setFieldValue("contato", "");
        onChangeContexto("");
        onChangeLocal("");
      }
    }
  }, [setDados]);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      validationSchema={validation}
      onSubmit={(values) => {
        onConfirmed(values);
      }}
    >
      {({ errors, touched }) => (
        <Form className={modalClasses}>
          <div
            className={`modal-container fixed inset-0 flex items-center justify-center ${
              isTablet ? "tablet" : ""
            }`}
          >
            <div className="modal-content bg-white px-14 py-14 rounded-[20px] shadow-lg relative z-40">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                >
                  <ModalClosed />
                </button>
              </div>
              <ModalSuccess />
              <h3 className="font-bold text-4xl max-w-[400px] text-center mt-2 mb-6 ml-auto mr-auto">
                {title}
              </h3>
              <div className="modal-content-flex">
                <div className="modal-content-flex--select">
                  <FormLabel className="field__label">
                    *Informe o <b>contexto</b> das informações onde foram
                    coletadas:
                  </FormLabel>
                  <Select
                    name="contextoId"
                    options={optionContextos}
                    spacingControl={true}
                    placeholder="Contexto"
                    onChange={(e) => onChangeContexto(e)}
                    noOptionsMessage="Contexto não encontrado"
                    errors={errors.contextoId}
                    touched={touched.contextoId}
                    {...contextoSelect}
                  />
                </div>

                <div className="modal-content-flex--select">
                  <FormLabel className="field__label mt-4">
                    *Informe o <b>Local</b> onde as informações foram
                    coletadas:
                  </FormLabel>
                  <Select
                    name="localId"
                    options={optionLocais}
                    spacingControl={true}
                    placeholder="Local"
                    onChange={(e) => onChangeLocal(e)}
                    noOptionsMessage="Local não encontrado"
                    errors={errors.localId}
                    touched={touched.localId}
                    {...localSelect}
                  />
                </div>

                <div>
                  <FormLabel className="field__label mt-4">
                    *Informe o <b>contato</b> que forneceu as informações
                    coletadas:
                  </FormLabel>
                  <InputField
                    labelName=""
                    inputName="contato"
                    inputMask="offmask"
                    inputType="text"
                  />
                </div>
              </div>

              <div className="container-button py-6 flex justify-end container">
                <button
                  type="submit"
                  className="flex items-center gap-x-2 text-white bg-quaternaria px-8 py-4 rounded font-bold credit-button-solicitacao"
                >
                  Confirmar <InfoArrow />
                </button>
              </div>
            </div>
            <div className={overlayClasses} onClick={onClose}></div>
          </div>
        </Form>
      )}
    </Formik>
  );
};


ModalForUpdate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  trilha: PropTypes.any,
  setDados: PropTypes.object,
  onConfirm: PropTypes.func,
};

export default ModalForUpdate;
